(function($) {
    'use strict';

    let $body = $(document.body);
    let $html = $('html');
    let $flyout = $('.flyout');

    $body.on('click', '.body-overlay', function(e) {
        if (e.target !== this) {
            return;
        }
        $body.trigger('flyout/hide');
    });

    $body.on('click', '.flyout-toggle', function() {
        var flyout = $(this).attr('data-flyout');
        $('body').attr('data-pos', $(window).scrollTop());
        $('body').removeClass('lang-open');
        $('.lang-wrp').removeClass('active');
        $flyout.removeClass('active');
        $html.addClass('flyout-open');
        $('[data-flyout=' + flyout + ']').addClass('active');
        history.pushState({}, '');
    });

    class Flyout {
        constructor() {
            $body.on(
                'click',
                '.flyout-close',
                this.flyout_hide,
            );
            $(document).on('flyout/hide', this.flyout_hide);
        }

        flyout_hide = () => {
            var scrolltop = $('body').attr('data-pos');
            $(window).scrollTop(scrolltop);
            $flyout.removeClass('active');
            $html.removeClass('flyout-open');
        };
    }

    new Flyout();

    window.onpopstate = function() {
        $body.trigger('flyout/hide');
    };

}(jQuery));
